import {Card} from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import useMotivationPrinciples from "@oldDashboard/legacyHooks/useMotivationPrinciples";
import Loader from "@/components/common/loader/loader";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";
import { getFiltersDate } from "@oldDashboard/legacyUtils";

interface MotivationPrinciplesUtilizedProps { timePeriods: TimePeriods[], affiliateSelected: any, launchSelected: String, timePeriodSelected: string, searching: boolean}
const MotivationPrinciplesUtilizedTile =(props:MotivationPrinciplesUtilizedProps) => {
    const {affiliateSelected, launchSelected,timePeriods,timePeriodSelected, searching } = props;
    const { startDate, endDate } = getFiltersDate(timePeriods,timePeriodSelected);
    const { isLoading, chartData } = useMotivationPrinciples({affiliateSelected, launchSelected, timePeriodSelected,startDate, endDate, searching});
    
    if((!chartData?.series && !chartData?.options)) return null;
    return (
        <Card className="custom-card" style={{height: '250px'}}>
            {isLoading && <Loader/> }
            <Card.Header>
                <Card.Title>Motivation Principles Utilized</Card.Title>
            </Card.Header>
            <Card.Body>
                <ReactApexChart 
                    options={chartData?.options}
                    series={chartData?.series}
                    type="bar"
                    height={175}
                    style={{marginTop: '-25px'}}
            />

            </Card.Body>
        </Card>
    );
};

export default MotivationPrinciplesUtilizedTile;
